<script setup lang="ts">
import { Notifications } from '@kyvg/vue3-notification'
import { ModalsContainer } from 'vue-final-modal'
import { createSocket } from './libs'
import { useSocketStore, useUserStore } from './store'

const userStore = useUserStore()
const socketStore = useSocketStore()
const userId = computed(() => userStore.user?.user_id)

watch(userId, (newUserId) => {
  if (!newUserId)
    return

  const socket = createSocket()
  socketStore.setSocket(socket)

  if (!socketStore?.socket?.connected) {
    socketStore.socket?.connect()
  }
})
</script>

<template>
  <router-view />
  <notifications position="bottom right" />
  <modals-container />
</template>

<style scoped>
</style>
